import ResourcesAddButton from './ResourcesAddButton';
import ResourceAdd from './ResourceForm/AddResourceFormContainer';
import ResourceDetails from './ResourceDetails/ResourceDetailsContainer';
import ResourceEdit from './ResourceForm/EditResourceFormContainer';
import ResourceList from './ResourcesList/ResourcesListContainer';
import ResourcesEmpty from './ResourcesEmpty/ResourcesEmpty';

export { selectResources, selectResourcesIsLoading } from './Resources.selectors';
export { watchActions as watchResourcesActions } from './Resources.saga';
export const ResourcesComponents = {
  add: ResourceAdd,
  addButton: ResourcesAddButton,
  details: ResourceDetails,
  edit: ResourceEdit,
  list: ResourceList,
  empty: ResourcesEmpty,
};
export { default as DeleteResourceModal } from './DeleteResourceModal/DeleteResourceModal';
